import { render, staticRenderFns } from "./AdminCrawlReports.vue?vue&type=template&id=6063623d&scoped=true&"
import script from "./AdminCrawlReports.vue?vue&type=script&lang=js&"
export * from "./AdminCrawlReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminCrawlReports.vue?vue&type=style&index=0&id=6063623d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063623d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6063623d')) {
      api.createRecord('6063623d', component.options)
    } else {
      api.reload('6063623d', component.options)
    }
    module.hot.accept("./AdminCrawlReports.vue?vue&type=template&id=6063623d&scoped=true&", function () {
      api.rerender('6063623d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCrawlReports.vue"
export default component.exports